import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import { Tab, Tabs } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Society } from '../../../app/models/Society';
import { Provider } from '../../../app/models/Provider';
import DefaultCard from '../../../components/default/DefaultCard';
import DefaultModal from '../../../components/default/DefaultModal';
import GeneralDocumentsTransporterTable from '../../../components/GeneralDocumentsTransporterTable';
import LazyLoading from '../../../components/LazyLoading';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
// import CarrierHistoryDocument from '../components/CarrierHistoryDocument';
import { TruckDataForm, TruckDocument } from '../../../app/models/Truck';
import { Brand } from '../../../app/models/Brand';
import { VehicleModel } from '../../../app/models/VehicleModel';
import useTruckService from '../../../app/services/hooks/useTruckService';
import TruckForm from '../components/forms/TruckForm';
import TruckDocumentCreate from '../components/TruckDocumentCreate';
import TruckDocumentHistory from '../components/TruckDocumentHistory';
import { AuthContext } from '../../../contexts/AuthContext';
import { Status } from '../../../app/models/Status';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { DocumentSet } from '../../../app/models/DocumentSet';
import useTruckDocumentService from '../../../app/services/hooks/useTruckDocumentService';
import DocumentsDataTable from '../../../components/DocumentsDataTable';
import { DocumentNameFilters } from '../../../app/models/Document';
import TruckDocumentEdit from '../components/TruckDocumentEdit';
import TruckFuelConsumptionContainer from '../components/TruckFuelConsumptionContainer';

type RouterParams = {
    id: string;
};

const TruckEdit = () => {
    const history = useHistory();
    const { showLoading, hideLoading, changeAnimation,showProgressiveLoading } = useContext(AppContext);
    const { auth } = useContext(AuthContext);
    
    const { id } = useParams<RouterParams>();
    const [verifyingTruck, setVerifyingTruck] = useState<boolean>(true);
    const { getTruckDocumentsByTruck,getTruckDocumentBySet,deleteTruckDocument,fetchingGetTruckDocuments } = useTruckDocumentService();
    const [societies, setSocieties] = useState<Society[]>([]);
    const [providers, setProviders] = useState<Provider[]>([]);
    const [brands, setBrands] = useState<Brand[]>([]);
    const [vehicleModels, setVehicleModels] = useState<VehicleModel[]>([]);
    const [documentSets, setDocumentSets] = useState<DocumentSet[]>([]);
    const [status, setStatus] = useState<Status[]>([]);
    const [truck, setTruck] = useState<TruckDataForm>({ ['is_internal']: undefined });
    const [copyTruck, setCopyTruck] = useState<TruckDataForm>();
    const [documentTypes, setDocumentTypes] = useState<any[]>([]);
    const [showingCreateDocument, setShowingCreateDocument] = useState(false);
    const [showingHistoryDocument, setShowingHistoryDocument] = useState(false);
    const [showingEditDocument, setShowingEditDocument] = useState(false);
    const [typeDocumentSelected, setTypeDocumentSelected] = useState<any>();
    const [errorFields, setErrorFields] = useState<any>();
    const [filter, setFilter] = useState<DocumentNameFilters>({
        document_name: ''
    })
    const { editTruck, updateTruck, fetchingEditTruck, fetchingUpdateTruck } = useTruckService();

    useEffect(() => {
        edit(parseInt(id));
    }, [id]);

    useEffect(() => {
        getDocuments(parseInt(id));
    }, []);

    const reloadTable = () => {
        getDocuments(parseInt(id));
    }

    console.log(auth)

    useEffect(() => {
        if (truck?.is_internal == copyTruck?.is_internal) {
            if (truck?.is_internal == true) {
                setTruck({
                    ...truck,
                    society_id: copyTruck?.society_id,
                    provider_id: undefined,
                    is_internal: true
                });
            } else if (truck?.is_internal == false) {
                setTruck({
                    ...truck,
                    provider_id: copyTruck?.provider_id,
                    society_id: undefined,
                    is_internal: false
                });
            }
        } else {
            if (truck?.is_internal == true) {
                setTruck({
                    ...truck,
                    society_id: 0,
                    provider_id: undefined,
                    is_internal: true
                });
            } else if (truck?.is_internal == false) {
                setTruck({
                    ...truck,
                    provider_id: 0,
                    society_id: undefined,
                    is_internal: false
                });
            }
        }
    }, [truck?.is_internal]);

    const edit = (id: number) => {
        editTruck(id, {
            onSuccess: (response: ServiceResponse) => {
                setSocieties(response.data.societies);
                setProviders(response.data.providers);
                setBrands(response.data.brands);
                setVehicleModels(response.data.vehicle_models);
                setStatus(response.data.status);
                setCopyTruck(response.data.truck);
                setDocumentSets(response.data.document_sets);
                setTruck(response.data.truck);
                setVerifyingTruck(false);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    history.goBack();
                }
            }
        });
        getDocuments(id);
    };
    

    const update = () => {
        if (truck) {
            if (showLoading) showLoading('loading', 'Actualizando tracto...');

            updateTruck(Number(truck?.id), truck, {
                onSuccess: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();

                    useReactConfirmAlert().successAlert({
                        title: 'Éxito',
                        message: response.message
                    });
                    toast.success(response.message, {
                        autoClose: 2500
                    });
                    setErrorFields(undefined);
                    edit(parseInt(id));
                },
                onError: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    useReactConfirmAlert().errorAlert({
                        title: 'Error',
                        message: response.message
                    });
                },
                onFieldError: (errorFields: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    setErrorFields(errorFields.data);
                }
            });
        }
    };

    const destroy = (DocumentId: number) => {
        const _text = 'Está a punto de eliminar el documento de el Tracto #' + Number(truck?.id);

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando documento...');
                        deleteTruckDocument(Number(truck?.id),DocumentId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El documento no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    const getDocuments = (id: number) => {
        getTruckDocumentsByTruck(id, filter, {
            onSuccess: (response: ServiceResponse) => {
                setDocumentTypes(response.data.truck_documents);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    history.goBack();
                }
            }
        });
    };

    const handleGetDocumentSet = (documentSetId: number): void => {
        // if (!documentSetId) {
        //     toast.error('Seleccione un set de documentos');
        //     return;
        // }
        getTruckDocumentBySet(parseInt(id), documentSetId);
    };
    
    

    const showCreateDocument = (type: string) => {
        setTypeDocumentSelected(type);
        setShowingCreateDocument(true);
    };

    const hideCreateDocument = () => {
        setShowingCreateDocument(false);
    };

    const showHistoryDocument = (type: string) => {
        setTypeDocumentSelected(type);
        setShowingHistoryDocument(true);
    };

    const hideHistoryDocument = () => {
        setShowingHistoryDocument(false);
    };

    const showEditDocument = (type: string) => {
        setTypeDocumentSelected(type);
        setShowingEditDocument(true);
    };

    const hideEditDocument = () => {
        setShowingEditDocument(false);
    };

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Tractos',
            url: '/trucks',
            isActive: false
        },
        {
            name: 'Editar #' + id,
            url: '/trucks/' + id + '/edit',
            isActive: true
        }
    ];

    if (fetchingEditTruck) {
        return (
            <DefaultCard>
                <LazyLoading height={300} />
            </DefaultCard>
        );
    }

    return (
        <>
            <Breadcrumbs pageSection={`Editar #${id}`} breadcrumbs={breadcrumbs} />

            {/* Tabs */}

            <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                <Tab eventKey="general-data" title="Datos Generales">
                    <div className="row">
                        <div className="col-md-6">
                            <DefaultCard>
                                <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                                {truck && (
                                    <TruckForm
                                        truckForm={truck}
                                        setTruckForm={setTruck}
                                        societies={societies}
                                        providers={providers}
                                        brands={brands}
                                        vehicleModels={vehicleModels}
                                        status={status}
                                        isEdit={true}
                                        documentSets={documentSets}
                                        errorFields={errorFields}
                                    />
                                )}
                                <div className="row justify-content-end">
                                    <div className="col-auto">
                                        <ButtonSaveForm
                                            callbackSave={update}
                                            locked={fetchingUpdateTruck}
                                        />
                                    </div>
                                </div>
                            </DefaultCard>
                        </div>
                    </div>
                </Tab>

                <Tab eventKey="management" title="Gestión" disabled>
                    Gestión
                </Tab>

                <Tab eventKey="fuel-consumption" title="Consumo" >
                    <div className="row">
                        <div className="col-md-12">
                            <DefaultCard>
                                <div className="h3 mt-0 mb-2 card-title">Consumo de Combustible</div>
                                {truck && truck.id && (
                                    <TruckFuelConsumptionContainer
                                        truckId={truck.id}
                                    />
                                )}
                            </DefaultCard>
                        </div>
                    </div>
                </Tab>
            </Tabs>

            {truck && (
                <div className="row">
                    <div className="col-md-12">
                        <DefaultCard>
                            <div className="h3 mt-0 mb-2 card-title">Documentos</div>
                            <DocumentsDataTable
                                data={documentTypes}
                                create={showCreateDocument}
                                showHistory={showHistoryDocument}
                                edit={showEditDocument}
                                destroy={destroy}
                                progressPending={fetchingGetTruckDocuments}
                                filter={filter}
                                setFilter={setFilter}
                                onSearch={reloadTable}
                                documentSets={documentSets}
                                getDocumentSet={handleGetDocumentSet}
                                documentType="truck"
                            />
                        </DefaultCard>
                    </div>
                </div>
            )}

            {showingCreateDocument ? (
                <DefaultModal
                    show={showingCreateDocument}
                    handleClose={hideCreateDocument}
                    title="Agregar Documento"
                    backdrop={true}
                    showFooter={false}
                >
                    <TruckDocumentCreate
                        onSaved={() => {
                            edit(parseInt(id));
                            hideCreateDocument();
                        }}
                        typeDocument={typeDocumentSelected}
                        truckId={Number(truck?.id)}
                        onCancel={hideCreateDocument}
                        onError={hideCreateDocument}
                    />
                </DefaultModal>
            ) : null}

            {showingEditDocument ? (
                <DefaultModal
                    show={showingEditDocument}
                    handleClose={hideEditDocument}
                    title="Editar Fechas del Documento"
                    backdrop={true}
                    showFooter={false}
                >
                    <TruckDocumentEdit
                        onSaved={() => {
                            hideEditDocument()
                            edit(parseInt(id));
                        }}
                        typeDocument={typeDocumentSelected}
                        truckId={Number(truck?.id)}
                        onCancel={hideEditDocument}
                        onError={hideEditDocument}
                    />
                </DefaultModal>
            ) : null}

            {showingHistoryDocument ? (
                <DefaultModal
                    show={showingHistoryDocument}
                    handleClose={hideHistoryDocument}
                    title={`Historial de documentos de ${
                        documentTypes?.find(
                            (document_type: any) => document_type.id === typeDocumentSelected
                        ).document_name
                    }`}
                    backdrop={true}
                    size={'lg'}
                    showFooter={false}
                >
                    <TruckDocumentHistory
                        typeDocument={typeDocumentSelected}
                        truckId={Number(truck?.id)}
                        onCancel={hideHistoryDocument}
                        onError={hideHistoryDocument}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default TruckEdit;
